import { useState } from 'react';
import { useTranslate } from 'react-polyglot';

import { useModal } from '../../../../../../../bootstrap/application/components/app/components/ModalProvider/ModalProvider.context';
import { useHostClientContext } from '../../HostClientProvider/hooks/useHostClientContext';
import { FinishGameModal } from '../components/FinishGameModal/FinishGameModal';
import { downloadGameResultsFromClient } from '../utils/downloadGameResultsFromClient';

export const useOpenFinishGameModal = () => {
  const t = useTranslate();
  const [finishingGame, setFinishingGame] = useState(false);
  const { client } = useHostClientContext();
  const { openModal, closeModal } = useModal();

  const handleFinishGame = async () => {
    if (finishingGame) return;

    setFinishingGame(true);

    closeModal();

    try {
      await downloadGameResultsFromClient(client, t);

      await client.finishGame();
    } finally {
      setFinishingGame(false);
    }
  };

  const openFinishGameModal = () => {
    openModal(parentElement => (
      <FinishGameModal
        parentElement={parentElement}
        closeModal={closeModal}
        handleFinishGame={handleFinishGame}
      />
    ));
  };

  return { openFinishGameModal, finishingGame };
};
